/* eslint-disable import/first */
// Garage service (external)
// Usage:
//   import { garageService, garageServiceReady } from './garageService.js';
//   await garageServiceReady;
//   garageService.activeVehicle;

export const garageService = window._esc_GarageService || null
export const garageServiceReady = init()

async function init () {
    // Placeholder: in the future, the garage service will require an initialization step
}

// Quick fix re. reactivity issues related to using separate version of Vue for partindex
// components
import { Vue } from './partindex'
Vue.observable(garageService)



// WEBPACK FOOTER //
// ./src/resources/scripts/services/garageService.js